'use client';

import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { css } from '@bts-web/utils-style-engine';
import {
  LegalDocumentsTermLabel,
  LegalDocumentsTermLabelTranslations,
} from './LegalDocumentsTermLabel';
import { AcceptTermToggle } from '../../../../../../common/components/AcceptTermToggle/AcceptTermToggle.use-client';
import { HTMLRenderer } from '../../../../../../common';

interface AcceptOfferStockEtfEtcEligibleTermsProps {
  translations: LegalDocumentsTermLabelTranslations & {
    investingRiskToggle: string;
    stocksToggleNotAppropriate: string;
  };
  legalDocumentUrl: string;
  setTermsAgreed: Dispatch<SetStateAction<boolean>>;
}

const AcceptOfferStockEtfEtcNonEligibleTerms = ({
  translations,
  legalDocumentUrl,
  setTermsAgreed,
}: AcceptOfferStockEtfEtcEligibleTermsProps) => {
  const [isFirstTermAgreed, setIsFirstTermAgreed] = useState(false);

  const [isSecondTermAgreed, setIsSecondTermAgreed] = useState(false);

  useEffect(() => {
    const areBothTermsAgreed = isFirstTermAgreed && isSecondTermAgreed;

    setTermsAgreed(areBothTermsAgreed);
  }, [isFirstTermAgreed, isSecondTermAgreed]);

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'small',
        alignItems: 'start',
        overflowX: 'hidden',
      })}
      data-testid="buy-terms-non-eligible"
      aria-label="buy terms non eligible"
    >
      <AcceptTermToggle
        termsAgreed={isFirstTermAgreed}
        onToggleCallback={() => setIsFirstTermAgreed((state) => !state)}
        label={
          <LegalDocumentsTermLabel
            translations={translations}
            links={{
              derivativeContractLink: legalDocumentUrl,
              prospectusLink: legalDocumentUrl,
              keyInformationDocumentLink: legalDocumentUrl,
              investorInformationDocumentLink: legalDocumentUrl,
              costTransparencyDocumentsLink: legalDocumentUrl,
            }}
          />
        }
        data-testid="documents"
      />

      <AcceptTermToggle
        termsAgreed={isSecondTermAgreed}
        onToggleCallback={() => setIsSecondTermAgreed((state) => !state)}
        label={<HTMLRenderer>{translations.investingRiskToggle}</HTMLRenderer>}
        detailedDescription={translations.stocksToggleNotAppropriate}
        data-testid="risk"
      />
    </div>
  );
};

export { AcceptOfferStockEtfEtcNonEligibleTerms };
